

import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateTeacherModal = ({ show, closeModal, teacherData, refreshTeachers }) => {
  const isEdit = Boolean(teacherData);


  const [name, setName] = useState("");
  const [email, setEmail] = useState("");


  const [classPermission, setClassPermission] = useState(0);
  const [studentPermission, setStudentPermission] = useState(1);
  const [examPermission, setExamPermission] = useState(1);
  const [editAnswerKey, setEditAnswerKey] = useState(0);
  const [resultPermission, setResultPermission] = useState(0);
  const [leaderBoard, setLeaderBoard] = useState(0);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (teacherData) {
      setName(teacherData.name || "");
      setEmail(teacherData.email || "");
      setClassPermission(teacherData.class_per || 0);
      setStudentPermission(teacherData.student || 0);
      setExamPermission(teacherData.exam || 0);
      setEditAnswerKey(teacherData.edit_answer_key || 0);
      setResultPermission(teacherData.result || 0);
      setLeaderBoard(teacherData.leader_board || 0);
    } else {
      setName("");
      setEmail("");
      setClassPermission(0);
      setStudentPermission(1);
      setExamPermission(1);
      setEditAnswerKey(0);
      setResultPermission(0);
      setLeaderBoard(0);
    }
  }, [teacherData]);

  if (!show) return null;

  const handleSave = async () => {
    if (!name || !email) {
      toast.error("Name and Email are required");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        name,
        email,
        class_per: classPermission,
        student: studentPermission,
        exam: examPermission,
        edit_answer_key: editAnswerKey,
        result1: resultPermission,
        leaderboard: leaderBoard
      };


      let result;
      if (isEdit) {
        result = await axios.put(`https://api.scannscore.com/edit-teacher/${teacherData.id}`, payload);

     
    if (result.status === 200) {
        toast.success("Teacher Updated Successfully");

        setTimeout(() => {
          closeModal();
        }, 2000);
      }
  
      } else {
        result = await axios.post(`https://api.scannscore.com/teacher`, payload);
          if (result.status === 200) {
        toast.success("Teacher Added Successfully");

        setTimeout(() => {
          closeModal();
        }, 2000);
      }
      }

     

    } catch (error) {
      toast.error("Error saving teacher:", error);
      // alert("Failed to save teacher. Check console for details.");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.35)",
        backdropFilter: "blur(6px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999
      }}
    >
      <div
        style={{
          position: "relative",
          background: "#fff",
          padding: "25px",
          borderRadius: "10px",
          width: "350px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.2)"
        }}
      >

        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            border: "none",
            background: "transparent",
            fontSize: "18px",
            cursor: "pointer"
          }}
        >
          ✕
        </button>

        <h3>{isEdit ? "Edit Teacher" : "Add Teacher"}</h3>

        <input
          placeholder="Enter Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "10px",
            border: "1px solid #ccc",
            borderRadius: "6px"
          }}
        />

        <input
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "10px",
            border: "1px solid #ccc",
            borderRadius: "6px"
          }}
        />

        <h5>Permissions</h5>

        <label>
          <input
            type="checkbox"
            checked={classPermission === 1}
            onChange={(e) => setClassPermission(e.target.checked ? 1 : 0)}
          /> Class
        </label>
        <br />

        <label>
          <input
            type="checkbox"
            checked={studentPermission === 1}
            onChange={(e) => setStudentPermission(e.target.checked ? 1 : 0)}
          /> Student
        </label>
        <br />

        <label>
          <input
            type="checkbox"
            checked={examPermission === 1}
            onChange={(e) => setExamPermission(e.target.checked ? 1 : 0)}
          /> Exam
        </label>
        <br />

        <label>
          <input
            type="checkbox"
            checked={editAnswerKey === 1}
            onChange={(e) => setEditAnswerKey(e.target.checked ? 1 : 0)}
          /> Edit Answer Key
        </label>
        <br />

        <label>
          <input
            type="checkbox"
            checked={resultPermission === 1}
            onChange={(e) => setResultPermission(e.target.checked ? 1 : 0)}
          /> Result
        </label>
        <br />

        <label>
          <input
            type="checkbox"
            checked={leaderBoard === 1}
            onChange={(e) => setLeaderBoard(e.target.checked ? 1 : 0)}
          /> Leader Board
        </label>

        <button
          onClick={handleSave}
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px",
            background: "#2649cf",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            marginTop: "15px",
            cursor: "pointer"
          }}
        >
          {loading ? "Saving..." : isEdit ? "Update Teacher" : "Add Teacher"}
        </button>
      </div>

   

       <ToastContainer
              position="top-center"
              autoClose={2000}
              theme="colored"
            />

    </div>
  );
};

export default CreateTeacherModal;


